// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scienceContainer {
  margin-top: 80px;
  padding: 50px;
}
.scienceContainer .details {
  padding-left: 20px;
}
.scienceContainer .details h3 {
  font-size: 1em;
}
.scienceContainer .moreTop {
  padding: 15px;
}
.scienceContainer .item {
  min-height: 150px;
  padding: 20px;
}
.scienceContainer .item h3 {
  padding: 10px;
  padding-left: 0;
  margin-top: 30px;
}
.scienceContainer .pdfContainer a {
  display: inline-block;
}
.scienceContainer .pdfContainer a > button > i {
  font-size: 25px;
}
.scienceContainer .links {
  padding-left: 20px;
}

.yearHeader {
  background-color: rgba(255, 255, 255, 0.9);
  width: 100px;
  height: 70px;
  align-content: center;
  text-align: center;
  margin-left: 10px;
}
.yearHeader h2 {
  color: #37393b;
  margin: 0;
  font-size: 2em;
}

.scienceDate {
  display: inline-block;
  margin: 12px;
  margin-left: 0;
}

.doi {
  font-size: 0.9em;
  display: inline-block;
  margin-top: 10px;
  text-decoration: underline !important;
}

.authorsContainer {
  display: inline-block;
  margin: 5px;
}
.authorsContainer .authors {
  border-radius: 5px;
  display: inline-block;
  margin: 5px;
}
.authorsContainer .authors span {
  display: inline-block;
  margin: 3px;
  padding: 4px;
  background: inherit;
  margin: 5px;
  border: 2px solid #aaaaaa;
  border-radius: 5px;
}

.altmetric {
  background-color: white;
  border-radius: 150px;
  display: inline-block;
  margin: 15px;
}

.btn {
  display: block;
  color: black;
  text-decoration: underline;
  margin: 20px;
  margin-left: 0;
}

.btn:hover {
  background-color: rgba(0, 0, 0, 0);
}

.seeAll {
  text-align: center;
  font-size: 1.3em;
  width: 100%;
}
.seeAll h3 {
  display: inline-block;
  width: 200px;
  padding: 20px;
  text-decoration: underline;
  color: white;
  border-radius: 3px;
}

.scienceWidgetHeader,
.scienceHeader {
  width: 100%;
  color: black;
  padding: 20px;
  text-align: center;
  font-size: 2em;
  background-color: rgba(255, 255, 255, 0.9);
  margin-left: 5px;
}

.summaryContent {
  padding: 10px;
  height: 100%;
}

.badge-secondary {
  background-color: white;
  color: black;
  padding: 7px;
}

@media only screen and (max-width: 1400px) {
  .hideForSmall {
    display: none;
  }
  .summaryContent h3 {
    font-size: 0.8em !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/publicationswidget/publicationswidget.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,aAAA;AACF;AACE;EACE,kBAAA;AACJ;AACI;EACE,cAAA;AACN;AAGE;EACE,aAAA;AADJ;AAIE;EACE,iBAAA;EACA,aAAA;AAFJ;AAII;EACE,aAAA;EACA,eAAA;EACA,gBAAA;AAFN;AAOI;EACE,qBAAA;AALN;AAQI;EACE,eAAA;AANN;AAUE;EACE,kBAAA;AARJ;;AAYA;EACE,0CAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;AATF;AAYE;EACE,cAAA;EACA,SAAA;EACA,cAAA;AAVJ;;AAcA;EACE,qBAAA;EACA,YAAA;EACA,cAAA;AAXF;;AAcA;EACE,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,qCAAA;AAXF;;AAcA;EACE,qBAAA;EACA,WAAA;AAXF;AAaE;EAEE,kBAAA;EACA,qBAAA;EACA,WAAA;AAZJ;AAcI;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;AAZN;;AAiBA;EACE,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,YAAA;AAdF;;AAiBA;EACE,cAAA;EACA,YAAA;EACA,0BAAA;EACA,YAAA;EACA,cAAA;AAdF;;AAiBA;EACE,kCAAA;AAdF;;AAiBA;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;AAdF;AAgBE;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,0BAAA;EACA,YAAA;EACA,kBAAA;AAdJ;;AAkBA;;EAEE,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;EACA,0CAAA;EACA,gBAAA;AAfF;;AAkBA;EACE,aAAA;EACA,YAAA;AAfF;;AAkBA;EACE,uBAAA;EACA,YAAA;EACA,YAAA;AAfF;;AAkBA;EACE;IACE,aAAA;EAfF;EAkBE;IACE,2BAAA;EAhBJ;AACF","sourcesContent":[".scienceContainer {\r\n  margin-top: 80px;\r\n  padding: 50px;\r\n\r\n  .details {\r\n    padding-left: 20px;\r\n\r\n    h3 {\r\n      font-size: 1em;\r\n    }\r\n  }\r\n\r\n  .moreTop {\r\n    padding: 15px;\r\n  }\r\n\r\n  .item {\r\n    min-height: 150px;\r\n    padding: 20px;\r\n\r\n    h3 {\r\n      padding: 10px;\r\n      padding-left: 0;\r\n      margin-top: 30px;\r\n    }\r\n  }\r\n\r\n  .pdfContainer {\r\n    a {\r\n      display: inline-block;\r\n    }\r\n\r\n    a > button > i {\r\n      font-size: 25px;\r\n    }\r\n  }\r\n\r\n  .links {\r\n    padding-left: 20px;\r\n  }\r\n}\r\n\r\n.yearHeader {\r\n  background-color: rgba(255, 255, 255, 0.9);\r\n  width: 100px;\r\n  height: 70px;\r\n  align-content: center ;\r\n  text-align: center;\r\n  margin-left:10px;\r\n  \r\n\r\n  h2 {\r\n    color: #37393b;\r\n    margin:0;\r\n    font-size: 2em;\r\n  }\r\n}\r\n\r\n.scienceDate {\r\n  display: inline-block;\r\n  margin: 12px;\r\n  margin-left: 0;\r\n}\r\n\r\n.doi {\r\n  font-size: 0.9em;\r\n  display: inline-block;\r\n  margin-top: 10px;\r\n  text-decoration: underline !important;\r\n}\r\n\r\n.authorsContainer {\r\n  display: inline-block;\r\n  margin: 5px;\r\n\r\n  .authors {\r\n    //border: 2px solid #e1e1e180;\r\n    border-radius: 5px;\r\n    display: inline-block;\r\n    margin: 5px;\r\n\r\n    span {\r\n      display: inline-block;\r\n      margin: 3px;\r\n      padding: 4px;\r\n      background: inherit;\r\n      margin: 5px;\r\n      border: 2px solid #aaaaaa;\r\n      border-radius: 5px;\r\n    }\r\n  }\r\n}\r\n\r\n.altmetric {\r\n  background-color: white;\r\n  border-radius: 150px;\r\n  display: inline-block;\r\n  margin: 15px;\r\n}\r\n\r\n.btn {\r\n  display: block;\r\n  color: black;\r\n  text-decoration: underline;\r\n  margin: 20px;\r\n  margin-left: 0;\r\n}\r\n\r\n.btn:hover {\r\n  background-color: rgba(0, 0, 0, 0);\r\n}\r\n\r\n.seeAll {\r\n  text-align: center;\r\n  font-size: 1.3em;\r\n  width: 100%;\r\n\r\n  h3 {\r\n    display: inline-block;\r\n    width: 200px;\r\n    padding: 20px;\r\n    text-decoration: underline;\r\n    color: white;\r\n    border-radius: 3px;\r\n  }\r\n}\r\n\r\n.scienceWidgetHeader,\r\n.scienceHeader {\r\n  width: 100%;\r\n  color: black;\r\n  padding: 20px;\r\n  text-align: center;\r\n  font-size: 2em;\r\n  background-color: rgba(255, 255, 255, 0.9);\r\n  margin-left: 5px;\r\n}\r\n\r\n.summaryContent {\r\n  padding: 10px;\r\n  height: 100%;\r\n}\r\n\r\n.badge-secondary {\r\n  background-color: white;\r\n  color: black;\r\n  padding: 7px;\r\n}\r\n\r\n@media only screen and (max-width: 1400px) {\r\n  .hideForSmall {\r\n    display: none;\r\n  }\r\n  .summaryContent {\r\n    h3 {\r\n      font-size: 0.8em !important;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
